module.exports = __webpack_public_path__ + "assets/img/10icon.0d758222.png";